import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ChecklistItemComponent } from './checklist-item/checklist-item.component';
import { ChecklistItemModel } from './checklist.model';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'sb-checklist-content',
  templateUrl: './checklist-content.component.html',
  imports: [ChecklistItemComponent],
})
export class ChecklistContentComponent {
  items = input<ChecklistItemModel[]>([]);
  expandedItem: ChecklistItemModel | undefined;

  setExpandedItem(target: ChecklistItemModel) {
    this.expandedItem = target;
  }

  clearExpandedItem() {
    this.expandedItem = undefined;
  }
}
